
export enum RejectReason{
    NoAvatarAvailable,
    CacheMiss,
    BECallError
}

export class ExtendedErrorInfo {
    constructor(
        public reason:RejectReason,
        public errMsg:string
    ){}
}
